<template>

  <div
    class="flex flex-1 flex-col items-center justify-center my-8 w-full"
  >
    <div class="stepTitle activeText" id="stepTitle_0">
      you are here
    </div>

    <div ref="stepTree">
      <div
        v-for="step in this.LANDING_STEPS_TREE"
        class="flex flex-col justify-center items-center w-full"
      >
        <how-it-works-horizontal
          ref="horizontal"
          :index="step.horizontal.index"
          :horizontal-line-position="step.horizontal.horizontalLinePosition"
        />

        <how-it-works-vertical
          ref="vertical"
          :index="step.vertical.index"
          :left="step.vertical.left"
          :right="step.vertical.right"
          :need-vertical-line="step.vertical.needVerticalLine"
        />
      </div>
    </div>

  </div>

</template>

<script>
import { LandingPageConstants } from './LandingPageConstants';

export default {
  name: 'HowItWorks',
  mixins: [LandingPageConstants],

  created() {
    window.addEventListener('scroll', this.howItWorksAnimation);
  },

  destroyed() {
    window.removeEventListener('scroll', this.howItWorksAnimation);
  },

  methods: {
    /**
     * this function is called when the page is scrolling for creating step point animation
     * */
    howItWorksAnimation() {
      let windowPresentYPos = window.pageYOffset;
      const stepTree = this.$refs['stepTree'];
      const stepTreeStartPos =
        stepTree.offsetTop -
        this.VIRTUAL_DIFFERENCE_FOR_STEP_POINTS +
        this.STEP_POINT_RADIUS;
      if (windowPresentYPos < stepTreeStartPos) {
        windowPresentYPos = stepTreeStartPos;
      }
      this.howItWorksTreeRecoloring(windowPresentYPos);
    },

    /**
     * here we recolor the steps according to the user's position.
     */
    howItWorksTreeRecoloring(windowPresentYPos) {
      let verticalRefs = this.$refs['vertical'];
      let horizontalRefs = this.$refs['horizontal'];

      /**
       * here we recolor stepTree parts
       */
      for (let i = 0; i < this.LANDING_STEPS_COUNT; ++i) {
        horizontalRefs[i].setColors(windowPresentYPos);
        verticalRefs[i].setColors(windowPresentYPos);
      }
    },
  },
};
</script>
